// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__DmN58","buttons":"Password_buttons__2fVUf"};